import { AccountCreationType } from 'apps/cdp-web-demo/app/types';
import { Radio as CDSRadio, RadioProps } from '@cbhq/cds-web/controls/Radio';
import { Box } from '@cbhq/cds-web/layout';

import styles from './AccountCreationType.module.css';

function Radio(props: RadioProps<AccountCreationType>) {
  return (
    <Box width="100%" className={props.disabled ? styles['disabled-item'] : ''}>
      <CDSRadio {...props} />
    </Box>
  );
}

export { Radio };
